(() => {
 const initialise = async root => {
  if(root.dataset.ready) return;
  root.dataset.ready='true';
  const labels=JSON.parse(root.querySelector('[data-review-i18n]').textContent);
  const label=(key,values={})=>Object.entries(values).reduce((text,[name,value])=>text.replaceAll(`{${name}}`,String(value)),labels[key]||'');
  const list=root.querySelector('[data-review-list]'), pagination=root.querySelector('[data-review-pagination]');
  const template=root.querySelector('[data-review-template]'), sort=root.querySelector('[data-review-sort]');
  const rating=root.querySelector('[data-review-rating]'), empty=root.querySelector('[data-review-empty]');
  const dialog=root.querySelector('[data-review-dialog]');
  root.querySelector('[data-review-write]').addEventListener('click',()=>dialog.showModal());
  root.querySelector('[data-review-close]').addEventListener('click',()=>dialog.close());
  const steps=[...dialog.querySelectorAll('[data-review-step]')];
  if(steps.length){
   let step=1,score=0;
   const scoreInput=dialog.querySelector('[data-review-rating-value]');
   const next=dialog.querySelector('[data-review-next]'),back=dialog.querySelector('[data-review-back]'),submit=dialog.querySelector('[data-review-submit]');
   const showStep=()=>{
    steps.forEach(panel=>{panel.hidden=Number(panel.dataset.reviewStep)!==step;panel.querySelectorAll('input,textarea').forEach(field=>field.disabled=panel.hidden);});
    back.hidden=step===1;next.hidden=step===3;submit.hidden=step!==3;
    dialog.querySelector(`[data-review-step="${step}"] :is(textarea,input:not([type="hidden"]))`)?.focus();
   };
   dialog.querySelectorAll('[data-review-score]').forEach(button=>button.addEventListener('click',()=>{
    score=Number(button.dataset.reviewScore);scoreInput.value=String(score);
    dialog.querySelectorAll('[data-review-score]').forEach(star=>{const on=Number(star.dataset.reviewScore)<=score;star.classList.toggle('jdgm--on',on);star.classList.toggle('jdgm--off',!on);star.setAttribute('aria-pressed',String(Number(star.dataset.reviewScore)===score));});
   }));
   next.addEventListener('click',()=>{
    if(!score){dialog.querySelector('[data-review-score]').focus();return;}
    const fields=[...steps[step-1].querySelectorAll('input,textarea')];
    if(fields.some(field=>!field.reportValidity()))return;
    step=Math.min(3,step+1);showStep();
   });
   back.addEventListener('click',()=>{step=Math.max(1,step-1);showStep();});
   dialog.querySelector('form').addEventListener('submit',event=>{
    if(step!==3||!score){event.preventDefault();return;}
    steps.forEach(panel=>panel.querySelectorAll('input,textarea').forEach(field=>field.disabled=false));
   });
   showStep();
  }
  if(dialog.querySelector('[data-review-response]'))dialog.showModal();
  const toggle=root.querySelector('[data-review-filter-toggle]'), filter=root.querySelector('.essentae-review-filter');
  toggle.addEventListener('click',()=>{filter.hidden=!filter.hidden;toggle.setAttribute('aria-expanded',String(!filter.hidden));});
  const response=await fetch(root.dataset.reviewJson);
  if(!response.ok)throw Error('Review data unavailable');
  const records=await response.json();let page=1;
  const summary=root.querySelector('[data-review-summary]');
  const paragraphs=summary.querySelectorAll('p');
  const average=records.reduce((sum,r)=>sum+r.rating,0)/Math.max(records.length,1);
  paragraphs[0].textContent=average.toFixed(1);paragraphs[1].textContent=label('count_label',{count:records.length});
  summary.querySelector('[role="img"]').setAttribute('aria-label',label('stars_label',{rating:average.toFixed(1)}));
  summary.querySelectorAll('.jm-star-rating__font-icon').forEach((s,i)=>{s.style.opacity=i<Math.round(average)?'1':'.2';});
  const disclosures=labels;
  const photoUrls=JSON.parse(root.querySelector('[data-review-photo-urls]').textContent);
  const photoDialog=root.querySelector('[data-review-photo-dialog]');
  let activePhotos=[],photoIndex=0;
  const showPhoto=()=>{
   photoDialog.querySelector('[data-photo-full]').src=photoUrls[activePhotos[photoIndex]];
   photoDialog.querySelector('[data-photo-full]').alt=label('photo_label');
   photoDialog.querySelector('[data-photo-previous]').disabled=photoIndex===0;
   photoDialog.querySelector('[data-photo-next]').disabled=photoIndex===activePhotos.length-1;
   const strip=photoDialog.querySelector('[data-photo-thumbnails]');strip.replaceChildren();
   activePhotos.forEach((url,index)=>{
    const button=root.querySelector('[data-photo-nav-template]').content.firstElementChild.cloneNode(true);button.type='button';
    button.classList.toggle('jm-media-grid__item--active',index===photoIndex);
    button.setAttribute('aria-label',label('photo_view_label'));button.setAttribute('aria-pressed',String(index===photoIndex));
    const img=button.querySelector('img');img.src=photoUrls[url];img.alt=label('photo_label');
    button.addEventListener('click',()=>{photoIndex=index;showPhoto();});strip.append(button);
   });
  };
  photoDialog.querySelector('[data-photo-close]').addEventListener('click',()=>photoDialog.close());
  photoDialog.querySelector('[data-photo-previous]').addEventListener('click',()=>{if(photoIndex>0){photoIndex--;showPhoto();}});
  photoDialog.querySelector('[data-photo-next]').addEventListener('click',()=>{if(photoIndex<activePhotos.length-1){photoIndex++;showPhoto();}});
  photoDialog.addEventListener('click',event=>{if(event.target===photoDialog)photoDialog.close();});
  function makeCard(review){
    const card=template.content.firstElementChild.cloneNode(true);
    card.dataset.reviewId=review.id;
    card.querySelector('[data-source-verified-badge]').hidden=!(review.sourceVerifiedBuyer&&review.sourceTransparencyBadges.includes('review_written_in_shop_app'));
    for(const [field,value] of Object.entries({author:review.author,initial:review.author[0],body:review.body}))card.querySelector(`[data-review-field="${field}"]`).textContent=value;
    if(review.title){
     const title=root.querySelector('[data-review-title-template]').content.firstElementChild.cloneNode(true);
     title.textContent=review.title;card.querySelector('.jm-review-content').prepend(title);
    }
    const star=card.querySelector('[role="img"]');star.setAttribute('aria-label',label('stars_label',{rating:review.rating}));
    star.querySelectorAll('.jm-star-rating__font-icon').forEach((s,i)=>{s.style.opacity=i<review.rating?'1':'.2';});
    const badges=card.querySelector('[data-review-field="disclosures"]');
    for(const key of review.sourceTransparencyBadges){if(!disclosures[key])continue;const p=document.createElement('p');p.textContent=disclosures[key];p.className='jm-text';badges.append(p);}
    if(!badges.childElementCount)badges.hidden=true;
    if(review.sourceVerifiedBuyer&&!review.sourceTransparencyBadges.includes('review_written_in_shop_app')){
     const badge=root.querySelector('[data-review-verified-template]').content.firstElementChild.cloneNode(true);
     card.querySelector('[data-source-verified-badge]').after(badge);
    }
    if(review.photos.length){
     const media=document.createElement('div');media.className='jm-media-thumbnail-list';media.dataset.reviewPhotos='';
     review.photos.forEach((url,index)=>{
      if(!photoUrls[url])throw Error('Unhosted review photo');
      const button=root.querySelector('[data-review-photo-template]').content.firstElementChild.cloneNode(true);
      button.querySelector('img').src=photoUrls[url];
      const open=()=>{
       activePhotos=review.photos;photoIndex=index;showPhoto();
       const details=card.cloneNode(true);details.querySelector('[data-review-photos]')?.remove();
       photoDialog.querySelector('[data-photo-review]').replaceChildren(details);photoDialog.showModal();
      };
      button.addEventListener('click',open);
      button.addEventListener('keydown',event=>{if(['Enter',' '].includes(event.key)){event.preventDefault();open();}});
      media.append(button);
     });
     card.querySelector('.jm-review-item__content').append(media);
    }
    return card;
  }
  const gallery=root.querySelector('[data-review-gallery]');
  const galleryStrip=gallery.querySelector('.jm-media-grid__container');
  gallery.querySelectorAll('[data-gallery-photo]').forEach(button=>{
   const source=button.dataset.galleryPhoto;
   const review=records.find(record=>record.photos.some(photo=>photo.split('?')[0]===source));
   const url=review?.photos.find(photo=>photo.split('?')[0]===source);
   button.dataset.galleryPhoto=url||source;
   if(!review||!photoUrls[url]){button.remove();return;}
   button.querySelector('img').src=photoUrls[url];
   button.addEventListener('click',()=>{
    activePhotos=review.photos;photoIndex=review.photos.indexOf(url);showPhoto();
    const details=makeCard(review);details.querySelector('[data-review-photos]')?.remove();
    photoDialog.querySelector('[data-photo-review]').replaceChildren(details);photoDialog.showModal();
   });
  });
  const galleryNext=gallery.querySelector('.jm-media-grid__arrow--next');
  galleryNext.addEventListener('click',()=>galleryStrip.scrollBy({left:galleryStrip.clientWidth*.8,behavior:'smooth'}));
  const galleryPrev=galleryNext.cloneNode(true);
  galleryPrev.classList.replace('jm-media-grid__arrow--next','jm-media-grid__arrow--prev');
  galleryPrev.setAttribute('aria-label',label('photo_scroll_previous'));
  galleryNext.setAttribute('aria-label',label('photo_scroll_next'));
  galleryPrev.querySelector('polyline').setAttribute('points','15,18 9,12 15,6');
  galleryPrev.addEventListener('click',()=>galleryStrip.scrollBy({left:-galleryStrip.clientWidth*.8,behavior:'smooth'}));
  galleryNext.before(galleryPrev);
  const galleryArrows=()=>{
   galleryPrev.hidden=galleryStrip.scrollLeft<1;
   galleryNext.hidden=galleryStrip.scrollLeft+galleryStrip.clientWidth>=galleryStrip.scrollWidth-1;
  };
  galleryStrip.addEventListener('scroll',galleryArrows,{passive:true});
  new ResizeObserver(galleryArrows).observe(galleryStrip);galleryArrows();
  function render(){
   let rows=records.filter(r=>!rating.value||r.rating===Number(rating.value));
   if(sort.value==='with_pictures')rows=rows.filter(r=>r.photos.length);
   rows=[...rows].sort((a,b)=>{
    if(sort.value==='highest_rating')return b.rating-a.rating||new Date(b.date)-new Date(a.date);
    if(sort.value==='lowest_rating')return a.rating-b.rating||new Date(b.date)-new Date(a.date);
    if(sort.value==='pictures_first')return b.photos.length-a.photos.length||new Date(b.date)-new Date(a.date);
    if(sort.value==='videos_first')return b.videos.length-a.videos.length||new Date(b.date)-new Date(a.date);
    return new Date(b.date)-new Date(a.date);
   });
   const total=Math.ceil(rows.length/5);page=Math.max(1,Math.min(page,total||1));list.replaceChildren();
   for(const review of rows.slice((page-1)*5,page*5)){
    list.append(makeCard(review));
   }
   empty.hidden=rows.length>0;
   const cluster=pagination.querySelector('.jm-cluster');cluster.replaceChildren();
   const pageButton=(role,target)=>{
    const button=root.querySelector(`[data-pagination-template="${role}"]`).content.firstElementChild.cloneNode(true);
    const disabled=target<1||target>total;button.disabled=disabled;button.classList.toggle('jm-button--disabled',disabled);
    button.addEventListener('click',()=>{page=target;render();root.scrollIntoView({block:'start',behavior:'smooth'});});
    return button;
   };
   pagination.hidden=total<2;
   cluster.append(pageButton('previous',page-1));
   const visible=total<=7?Array.from({length:total},(_,i)=>i+1):page<=3?[1,2,3,4,total]:page>=total-2?[1,total-3,total-2,total-1,total]:[1,page-1,page,page+1,total];
   let previous=0;
   for(const index of visible){
    if(previous&&index>previous+1)cluster.append(root.querySelector('[data-pagination-template="ellipsis"]').content.firstElementChild.cloneNode(true));
    const button=pageButton(index===page?'active':'page',index);button.querySelector('.jm-text').textContent=index;
    button.setAttribute('aria-label',label('page_label',{page:index}));if(index===page)button.setAttribute('aria-current','page');
    cluster.append(button);
    previous=index;
   }
   cluster.append(pageButton('next',page+1));
  }
  sort.value=sort.dataset.defaultSort||'highest_rating';sort.addEventListener('change',()=>{page=1;render();});rating.addEventListener('change',()=>{page=1;render();});render();
 };
 function scan(){document.querySelectorAll('.essentae-oregano-reviews').forEach(root=>initialise(root).catch(error=>{root.dataset.error=error.message;const msg=root.querySelector('[data-review-empty]');msg.hidden=false;try{msg.textContent=JSON.parse(root.querySelector('[data-review-i18n]').textContent).error_label;}catch{};}));}
 scan();document.addEventListener('shopify:section:load',scan);
})();
